import { MIGRATION_STATE } from "components/datanode/Constants";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import useMigrationState from "./useMigrationState";
import useRunsWithDataNode from "./useRunsWithDataNode";
const useShowDatanodeMigration = () => {
  const { permissions } = useCurrentUser();
  const canStartDataNode = isPermitted(permissions, "datanode:start");
  const { data: isDatanodeConfiguredAndUsed } = useRunsWithDataNode({ enabled: canStartDataNode });
  const { currentStep } = useMigrationState({ enabled: canStartDataNode });
  const migrationNeedsFinalization = (currentStep == null ? void 0 : currentStep.state) === MIGRATION_STATE.RESTART_GRAYLOG.key;
  const shouldShowDatanodeMigration = isDatanodeConfiguredAndUsed === false || isDatanodeConfiguredAndUsed === true && migrationNeedsFinalization;
  return {
    isDatanodeConfiguredAndUsed: canStartDataNode && isDatanodeConfiguredAndUsed === true,
    showDatanodeMigration: canStartDataNode && shouldShowDatanodeMigration
  };
};
export default useShowDatanodeMigration;
